import React from 'react'

import { ReactComponent as DaiStarIcon } from 'images/dai-star.svg'

const DaiStepIcon = ({ size, className }) => (
  <DaiStarIcon width={size} height={size} className={className} />
)

export default DaiStepIcon
